import ApiSmile from '@/api/api-smile';
import useDeviceFeature from '@/hooks/use-device-feature';
import MessageUtil from '@/util/message-util';
import Utils from '@/util/utils';
import React, {useEffect, useState} from 'react';
import './fund-summary.scss';

interface SummaryData {
    currentValue: number;
    currentYield: number;
    currentYieldRate: number;
    errorCount: number;
    fundPoolBalance: number;
    negativeYieldCount: number;
    positiveYieldCount: number;
    totalCost: number;
    totalProfit: number;
}

const LABEL: {[key: string]: string} = {
    totalCost: '持仓成本',
    currentValue: '当前价值',
    currentYield: '潜在收益',
    count: '正负收益量',
    fundPoolBalance: '资金池余额',
    totalProfit: '累计收益',
};

const FundSummary: React.FC = () => {
    const [data, setData] = useState<SummaryData>();
    const {isPhone} = useDeviceFeature();

    useEffect(() => {
        const load = async () => {
            const response: any = await ApiSmile.getFundSummary();
            if (response?.data?.code === 0) {
                setData(response.data.data);
            } else {
                const msg = response?.data?.msg || '网络请求失败';
                MessageUtil.error(msg);
            }
        };

        load();
    }, []);

    const itemClassName = `item ${isPhone ? 'item-phone' : ''}`;

    const items = data
        ? Object.keys(LABEL).map((item) => {
              if (item === 'currentYield') {
                  return (
                      <div key={item} className={itemClassName}>
                          <div className="yield">
                              <div className="value">{data[item as keyof SummaryData]}</div>
                              <span className="rate">{Utils.formatPercentage((data.currentYieldRate || 0) * 100)}</span>
                          </div>
                          <div className="label">{LABEL[item]}</div>
                      </div>
                  );
              } else if (item === 'count') {
                  return (
                      <div key={item} className={itemClassName}>
                          <div className="count">
                              <div className="value positive">{`+${data.positiveYieldCount}`}</div>
                              <div className="value negative">{`-${data.negativeYieldCount}`}</div>
                              {(data.errorCount || 0) > 0 && <div className="value error">{`E:${data.errorCount}`}</div>}
                          </div>
                          <div className="label">{LABEL[item]}</div>
                      </div>
                  );
              }

              return (
                  <div key={item} className={itemClassName}>
                      <div className="value">{data[item as keyof SummaryData]}</div>
                      <div className="label">{LABEL[item]}</div>
                  </div>
              );
          })
        : [];

    let rows: JSX.Element[];
    if (isPhone) {
        rows = [];
        let index = 0;
        while (items.length > 0) {
            const row = items.splice(0, 2);
            rows.push(
                <div key={`row-${index++}`} className="row">
                    {row}
                </div>,
            );
        }
    } else {
        rows = items;
    }

    return <div className={`fund-summary ${isPhone ? 'fund-summary-phone' : ''}`}>{rows}</div>;
};

export default FundSummary;
